import type { PipeTransform } from '@angular/core';
import { Pipe } from '@angular/core';

import { getUserInitials } from '../utils/user-initials.util';

@Pipe({
  name: 'userInitials',
  standalone: true,
})
export class UserInitialsPipe implements PipeTransform {
  transform(fullName: string): string;
  transform(firstName: string, lastName: string): string;
  transform(firstOrFull: string, last?: string): string {
    if (last !== undefined) {
      return getUserInitials(firstOrFull, last);
    }
    return getUserInitials(firstOrFull);
  }
}
